// extracted by mini-css-extract-plugin
export default {"holdAll":"Footer_holdAll__X1HKG","Location":"Footer_Location__bmsCm","AboutTiwa":"Footer_AboutTiwa__e+vEa","Support":"Footer_Support__g1DMF","Support1":"Footer_Support1__7SFVi"};